import api from '../api';
import spinner from './spinner';
import { factory } from 'zerocode';

const auth = factory.auth({ app: 'workflux', axiosCustomApis: [api], spinnerService: spinner });

export default auth;
